import { render, staticRenderFns } from "./EnterTerminationObjectsTable.vue?vue&type=template&id=f3ed04c8&scoped=true"
import script from "./EnterTerminationObjectsTable.vue?vue&type=script&lang=js"
export * from "./EnterTerminationObjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ed04c8",
  null
  
)

export default component.exports